import { render, staticRenderFns } from "./GroupTypeAutoAssigns.vue?vue&type=template&id=61fe192b&"
import script from "./GroupTypeAutoAssigns.vue?vue&type=script&lang=js&"
export * from "./GroupTypeAutoAssigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports